import { Language } from "../languages";

export const authTranslations: Record<Language, any> = {
  es: {
    login: {
      title: "Portal del Jugador",
      email: "Email",
      password: "Contraseña",
      login: "Iniciar Sesión",
      loggingIn: "Iniciando sesión...",
      forgotPassword: "¿Olvidaste tu contraseña?",
      success: "¡Inicio exitoso! Redirigiendo...",
      error: "Credenciales incorrectas o error de conexión",
    },
    register: {
      title: "Crear Cuenta",
      subtitle: "Únete a la aventura en Aethelbur Chronicles",
    },
    userPanel: {
      name: "Nombre",
      level: "Nivel",
      gold: "Oro",
      class: "Clase",
    },
  },
  en: {
    login: {
      title: "Player Portal",
      email: "Email",
      password: "Password",
      login: "Login",
      loggingIn: "Logging in...",
      forgotPassword: "Forgot your password?",
      success: "Login successful! Redirecting...",
      error: "Incorrect credentials or connection error",
    },
    register: {
      title: "Create Account",
      subtitle: "Join the adventure in Aethelbur Chronicles",
    },
    userPanel: {
      name: "Name",
      level: "Level",
      gold: "Gold",
      class: "Class",
    },
  },
};
